import { importScheduleDialogViewState } from "../";
import { IJobEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setImportScheduleJob", function setImportScheduleJob(job: IJobEntity) {
    importScheduleDialogViewState().job = job;
});